import * as React from 'react';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { PerfumerImage, PerfumerItemWrapper, Wrapper } from './styled';

type Props = {
  perfumers: Omit<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']['variants'][number]['features']['perfumers'],
    '__typename'
  >;
};

export const Perfumers = ({ perfumers }: Props) => {
  return (
    <Wrapper>
      {perfumers?.items.map((item) => (
        <PerfumerItemWrapper key={item.name}>
          <PerfumerImage
            src={item.imageUrl}
            alt={item.name}
            sourceKey="thumb"
          />
          <span>{item.name}</span>
        </PerfumerItemWrapper>
      ))}
    </Wrapper>
  );
};
